/* Copyright 2021, Milkdown by Mirone. */
import { calculateTextPosition } from '@milkdown/utils';
export const calcInputPos = (view, input) => {
    calculateTextPosition(view, input, (start, end, target, parent) => {
        const selectionWidth = end.left - start.left;
        let left = start.left - parent.left - (target.width - selectionWidth) / 2;
        const top = start.bottom - parent.top + 14;
        if (left < 0)
            left = 0;
        return [top, left];
    });
};
//# sourceMappingURL=calc-input-pos.js.map